import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import Logo from "components/layout/Logo";
import { categoriesApi } from "api";
import { FRONT_URL } from "lib/config";

// The site footer, same markup and styles (.yc-footer in styles/ui.css) as
// the frontpage's components/layout/SiteFooter.
// The Account column follows whether you are signed in, as on the frontpage.
export default function SiteFooter() {
  const signedIn = Boolean(useSelector((state) => state.users));
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    categoriesApi
      .all()
      .then((res) => setCategories(Array.isArray(res.data) ? res.data : []))
      .catch(() => {});
  }, []);

  const columns = [
    ["Categories", categories.map((c) => [c.name, `${FRONT_URL}/courses?category=${c.slug}`])],
    ["Classes", [["All classes", `${FRONT_URL}/courses`]]],
    ["Account", signedIn ? [["My classes", "/"], ["Profile", "/settings"], ["Order history", "/transactions"]] : [["Sign up", "/register"], ["Log in", "/login"]]],
  ].filter(([, links]) => links.length);

  return (
    <footer className="yc-footer">
      <div className="yc-footer-band">
        <div className="yc-container yc-footer-inner">
          <div className="yc-footer-top">
            <div className="yc-footer-brand">
              <Logo />
            </div>
            {columns.map(([title, links]) => (
              <div key={title} className="yc-footer-col">
                <h3>{title}</h3>
                <ul>
                  {links.map(([label, href]) => (
                    <li key={label}>{href.startsWith("/") ? <Link to={href}>{label}</Link> : <a href={href}>{label}</a>}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="yc-footer-mid">
            <b>Youwdin Class</b>
            <span>Learn web, AI and mobile from real builders.</span>
          </div>
        </div>
      </div>
      <div className="yc-footer-bottom">
        <div className="yc-container yc-footer-bottom-inner">
          <span>&copy; {new Date().getFullYear()} Youwdin Class</span>
          <a href={`${FRONT_URL}/courses`}>Browse all classes &rarr;</a>
        </div>
      </div>
    </footer>
  );
}
